var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._m(0),_c('img',{attrs:{"id":"resume","src":require(`@/assets/uxresume.jpg`)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro"},[_c('h1',[_vm._v("Resume")])])
}]

export { render, staticRenderFns }